/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addProfileIdea } from '../fn/profile-idea/add-profile-idea';
import { AddProfileIdea$Params } from '../fn/profile-idea/add-profile-idea';
import { BooleanResponse } from '../models/boolean-response';
import { ProfileIdeaResponse } from '../models/profile-idea-response';
import { repliedProfileIdea } from '../fn/profile-idea/replied-profile-idea';
import { RepliedProfileIdea$Params } from '../fn/profile-idea/replied-profile-idea';
import { userHasSeenProfileIdea } from '../fn/profile-idea/user-has-seen-profile-idea';
import { UserHasSeenProfileIdea$Params } from '../fn/profile-idea/user-has-seen-profile-idea';

@Injectable({ providedIn: 'root' })
export class ProfileIdeaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addProfileIdea()` */
  static readonly AddProfileIdeaPath = '/rest/profile/{id}/idea';

  /**
   * Add new profile idea from logged user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addProfileIdea()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProfileIdea$Response(params: AddProfileIdea$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileIdeaResponse>> {
    return addProfileIdea(this.http, this.rootUrl, params, context);
  }

  /**
   * Add new profile idea from logged user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addProfileIdea$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProfileIdea(params: AddProfileIdea$Params, context?: HttpContext): Observable<ProfileIdeaResponse> {
    return this.addProfileIdea$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileIdeaResponse>): ProfileIdeaResponse => r.body)
    );
  }

  /** Path part for operation `repliedProfileIdea()` */
  static readonly RepliedProfileIdeaPath = '/rest/profile/{profileId}/idea/{id}/reply';

  /**
   * Mark in database that profile idea has been replied (defined by id).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `repliedProfileIdea()` instead.
   *
   * This method doesn't expect any request body.
   */
  repliedProfileIdea$Response(params: RepliedProfileIdea$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return repliedProfileIdea(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark in database that profile idea has been replied (defined by id).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `repliedProfileIdea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  repliedProfileIdea(params: RepliedProfileIdea$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.repliedProfileIdea$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `userHasSeenProfileIdea()` */
  static readonly UserHasSeenProfileIdeaPath = '/rest/profile/{profileId}/idea/{id}/seen';

  /**
   * Mark in database that user (currently logged user) has seen profile idea (defined by id).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userHasSeenProfileIdea()` instead.
   *
   * This method doesn't expect any request body.
   */
  userHasSeenProfileIdea$Response(params: UserHasSeenProfileIdea$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return userHasSeenProfileIdea(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark in database that user (currently logged user) has seen profile idea (defined by id).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userHasSeenProfileIdea$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userHasSeenProfileIdea(params: UserHasSeenProfileIdea$Params, context?: HttpContext): Observable<void> {
    return this.userHasSeenProfileIdea$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
